import dayjs from 'dayjs';
import { enums } from '..';
import { shortResolutionFormatter } from './resolutionFormatter';

/**
 * Round up or truncate date to closest acceptable value
 * @param date
 * @param timeframe
 * @param multiplier
 * @returns
 */
export const formatDateByTimeframe = (date: number, timeframe: enums.ETimeframes | string, multiplier = 1000) => {
  const formatedDate = dayjs(date * multiplier);
  switch (timeframe) {
  case enums.ETimeframes.oneSecond:
    return formatedDate
      .set('milliseconds', 0)
      .valueOf();
  case enums.ETimeframes.fiveSeconds:
    return formatedDate
      .set('milliseconds', 0)
      .subtract(5 - formatedDate.second() % 5 , 'seconds')
      .valueOf();
  case enums.ETimeframes.tenSeconds:
    return formatedDate
      .set('milliseconds', 0)
      .subtract(10 - formatedDate.second() % 10 , 'seconds')
      .valueOf();
  case enums.ETimeframes.minute:
    return formatedDate
      .set('seconds', 0)
      .set('milliseconds', 0)
      .valueOf();
  case enums.ETimeframes.threeMinutes:
    return formatedDate
      .set('seconds', 0)
      .set('milliseconds', 0)
      .subtract(3 - formatedDate.minute() % 3 , 'minutes')
      .valueOf();
  case enums.ETimeframes.fiveMinute:
    return formatedDate
      .set('seconds', 0)
      .set('milliseconds', 0)
      .subtract(5 - formatedDate.minute() % 5 , 'minutes')
      .valueOf();
  case enums.ETimeframes.fifteenMinutes:
    return formatedDate
      .set('seconds', 0)
      .set('milliseconds', 0)
      .subtract(15 - formatedDate.minute() % 15 , 'minutes')
      .valueOf();
  case enums.ETimeframes.thirtyMinutes:
    return formatedDate
      .set('seconds', 0)
      .set('milliseconds', 0)
      .subtract(30 - formatedDate.minute() % 30 , 'minutes')
      .valueOf();
  case enums.ETimeframes.hour:
    return formatedDate
      .set('minutes', 0)
      .set('seconds', 0)
      .set('milliseconds', 0)
      .valueOf();
  case enums.ETimeframes.twoHours:
    return formatedDate
      .set('minutes', 0)
      .set('seconds', 0)
      .set('milliseconds', 0)
      .subtract(2 - formatedDate.hour() % 2 , 'hours')
      .valueOf();
  case enums.ETimeframes.fourHours:
    return formatedDate
      .set('minutes', 0)
      .set('seconds', 0)
      .set('milliseconds', 0)
      .subtract(4 - formatedDate.hour() % 4 , 'hours')
      .valueOf();
  case enums.ETimeframes.sixHours:
    return formatedDate
      .set('minutes', 0)
      .set('seconds', 0)
      .set('milliseconds', 0)
      .subtract(6 - formatedDate.hour() % 6 , 'hours')
      .valueOf();
  case enums.ETimeframes.twelveHours:
    return formatedDate
      .set('minutes', 0)
      .set('seconds', 0)
      .set('milliseconds', 0)
      .subtract(12 - formatedDate.hour() % 12 , 'hours')
      .valueOf();
  case enums.ETimeframes.day:
    return formatedDate
      .set('minutes', 0)
      .set('seconds', 0)
      .set('milliseconds', 0)
      .valueOf();
  default:
    return formatedDate
      .set('minutes', 0)
      .set('seconds', 0)
      .set('milliseconds', 0)
      .valueOf();
  }
};

export const mapInterval = (interval: string) => {
  return shortResolutionFormatter(interval);
};